window.addEventListener('DOMContentLoaded', () => {
  $('#check01').on('click', () => {
    if($('#check01:checked').val()) {
      $("#submit_button").prop("disabled", false);
      $("#submit_button").removeClass('btn-color-06').addClass('btn-color-07')
      $("#term-checkbox").toggleClass('checked')
    } else {
      $("#submit_button").prop("disabled", true);
      $("#submit_button").removeClass('btn-color-07').addClass('btn-color-06')
      $("#term-checkbox").toggleClass('checked')
    }
  });
});
